import React from 'react';
import { Box, InputAdornment, Grid } from '@mui/material';

import {
  Typography,
  TextField,
  ToggleButtonGroupField,
  CurrencyInputField,
  ProductGroupSelectField,
} from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import {
  TransactionDiscountAwardType,
  TransactionDiscountFormValues,
} from '@occc-app/routes/Promotion/types';

const buttons = [
  { title: 'Percent', value: TransactionDiscountAwardType.PercentDiscount },
  { title: 'Dollars', value: TransactionDiscountAwardType.MoneyDiscount },
];

type TransactionDiscountConfigurationProps = {
  values: TransactionDiscountFormValues;
};

export const TRANSACTION_DISCOUNT_FORM_PREFIX = 'transactionDiscount';

export const TransactionDiscountConfiguration: React.FC<TransactionDiscountConfigurationProps> = ({
  values,
}) => {
  return (
    <>
      <Box pb={3}>
        <Typography variant='subtitle1' gutterBottom>
          Member Receive
        </Typography>
        <Grid container spacing={3}>
          <Grid item>
            <ToggleButtonGroupField
              name={`${TRANSACTION_DISCOUNT_FORM_PREFIX}.awardType`}
              buttons={buttons}
            />
          </Grid>
          <Grid item xs={3}>
            {values?.awardType === TransactionDiscountAwardType.PercentDiscount && (
              <TextField
                name={`${TRANSACTION_DISCOUNT_FORM_PREFIX}.percentDiscount`}
                fieldProps={{
                  parse: parseNumber,
                }}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>%</InputAdornment>,
                }}
              />
            )}
            {values?.awardType === TransactionDiscountAwardType.MoneyDiscount && (
              <CurrencyInputField name={`${TRANSACTION_DISCOUNT_FORM_PREFIX}.moneyDiscount`} />
            )}
          </Grid>
        </Grid>
      </Box>
      <Typography variant='subtitle1' gutterBottom>
        When they spend at least
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <CurrencyInputField
            name={`${TRANSACTION_DISCOUNT_FORM_PREFIX}.purchaseAmountThreshold`}
            label='Dollar(s)'
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='subtitle1' gutterBottom>
            Does not apply on the following product group(s):
          </Typography>
          <ProductGroupSelectField
            inputProps={{
              margin: 'none',
            }}
            name={`${TRANSACTION_DISCOUNT_FORM_PREFIX}.ineligibleProductGroups`}
            label='Product groups'
          />
        </Grid>
      </Grid>
    </>
  );
};
